import React from 'react'
import classNames from 'classnames'
import { trackEvent } from '../../../utilities/analytics'

class Select extends React.Component {

  constructor(props) {
    super(props)
    this.handleChange = this.handleChange.bind(this)
  }

  handleChange(event) {
    if (this.props.onChange) {
      const {input} = this.props

      let value = event.target.value
      if (value.indexOf('-') !== -1) { // if range
        let values = value.split('-')
        value = {
          min: values[0],
          max: values[1]
        }
      }

      const selectedOption = input.options[event.target.selectedIndex]

      trackEvent({
        category: 'Filter',
        action: 'Selection',
        label: `${input.analyticsLabel} / ${selectedOption.label}`
      })

      this.props.onChange({
        valueFor: input.valueFor,
        value: value
      })
    }
  }

  render() {
    const {input, value} = this.props

    let current_value = value
    // if range
    if (current_value.min !== undefined && current_value.max !== undefined) {
      // join the values
      current_value = current_value.min + '-' + current_value.max
    }


    return (
      <select
        className={classNames('filter-select', `filter-select-${input.valueFor}` )}
        onChange={this.handleChange}
        value={current_value}
      >
      {input.options.map(function(option, index) {
        let label = option.label
        let count = option.count
        if (count !== undefined && count !== null) {
          let singularOrPlural = count === 1 ? 'unit' : 'units'
          label += ` (${count} ${singularOrPlural})`
        }
        return (
          <option key={index} value={option.value}>
            {label}
          </option>
        );
      })}
      </select>
    )
  }
}

Select.defaultProps = {
  input: null
}

export default Select
